import { InlineAlertType, InlineAlertWidget } from '@tableau/widgets';
import React from 'react';

import { BridgeSiteSettingsProps } from '~src/settings/general-settings/components/bridge-settings/BridgeSiteSettings';
import { BridgeRemoteAgentsSectionBody } from '~src/settings/general-settings/components/sections/bridge/BridgeRemoteAgentsSection/BridgeRemoteAgentsSectionBody';
import { BridgeRemoteAgentsSectionHeaders } from '~src/settings/general-settings/components/sections/bridge/BridgeRemoteAgentsSection/BridgeRemoteAgentsSectionHeaders';
import { FeatureFlags } from '~src/ts/FeatureFlags';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { multiPoolTableStyle, sectionExtraPaddingBottom } from './BridgeMultiPoolSection/BridgeMultiPoolSection';

export function BridgeDefaultRemoteAgentsSection(props: BridgeSiteSettingsProps) {
  const title = FeatureFlags.edgeMultiPoolEnabled ? '' : Messages.siteRemoteAgentSettingsAgentsStatus();
  const tableClass = FeatureFlags.edgeMultiPoolEnabled
    ? `${multiPoolTableStyle} ${sectionExtraPaddingBottom}`
    : 'tb-static-grid-table';

  return (
    <SettingsSection title={title}
      testId={'bridge-default-remote-agents-section'}>
      {FeatureFlags.edgeMultiPoolEnabled &&
        <div>
          <div className={'tb-data-grid-title-text'}>{Messages.siteRemoteAgentSettingsDefaultPool()}</div>
          <InlineAlertWidget testId={'default-pool-removal-alert'} type={InlineAlertType.Warning} style={{ marginBottom: 10 }}>
            {Messages.siteRemoteAgentSettingsDefaultPoolRemovalAlert()}
          </InlineAlertWidget>
        </div>
      }
      <div>
        <table className={`${tableClass} tb-static-grid-table-remote-agents-width`}>
          <BridgeRemoteAgentsSectionHeaders isDefaultPool={true} />
          <BridgeRemoteAgentsSectionBody
            isDefaultPool={true}
            pools={props.edgePools.userDefinedPools}
            connectionStatuses={props.connectionStatuses}
            siteId={props.settings.id}
            refreshEdgePools={props.refreshEdgePools}
            agents={Object.values(props.edgePools.defaultPoolAgents)}
            hasLoadedEdgePools={props.hasLoadedEdgePools}
          />
        </table>
      </div>
    </SettingsSection>
  );
}

/* for registering the component in settings registry */
export const BridgeDefaultRemoteAgentsSectionSpecs = componentRegistryEntry({
  name: 'BridgeDefaultRemoteAgentsSection',
  component: BridgeDefaultRemoteAgentsSection
});
